import { Calendar } from "primereact/calendar"
import React from "react";
import { useTranslation } from "react-i18next";
import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend, AreaChart, Area, Tooltip, LineChart, Line, ComposedChart, PieChart, Pie, Cell } from "recharts"


const fmColor = "rgb(218, 228, 86)"
const ffmColor = "rgb(144, 218, 71)"
const smmColor = "rgb(225, 88, 108)"
const tbwColor = "rgb(88, 175, 225)"
const unsetColor = "rgb(0,0,0,0)"

export const BiaGraph = ({
    biaData,
    patientInfo,
    date,
    onDateChange = (e) => { }
}) => {

    const [t] = useTranslation(["global", "health"]);

    let bia = biaData?.length > 0 ? biaData[biaData.length-1] : null

    let fatRatios
    let waterRatios
    let muscleRatios

    let fmRatio
    let ffmRatio

    let SMI
    let FMI
    let FFMI
    let BMI

    if (bia) {
        let fatMass = Math.round((bia.weight * (bia.fat_ratio / 100))*10)/10
        let fatFreeMass = bia.weight - fatMass


        fmRatio = bia.fat_ratio.toFixed(1)
        ffmRatio = (100 - bia.fat_ratio).toFixed(1)

        fatRatios =
            [
                { name: "FM", value: fatMass, color: fmColor },
                { name: "FFM", value: fatFreeMass, color: ffmColor }
            ]
        waterRatios =
            [
                { name: "TBW", value: bia.water, color: tbwColor },
                { name: "-", value: bia.weight - bia.water, color: unsetColor }
            ]
        muscleRatios =
            [
                { name: "SMM", value: bia.muscle_mass, color: smmColor },
                { name: "-", value: bia.weight - bia.muscle_mass, color: unsetColor }
            ]

        SMI = ((bia.muscle_mass / bia.weight) * 100).toFixed(1)

        if (patientInfo) {
            let height = patientInfo.height / 100
            FMI = (fatMass / (height ^ 2)).toFixed(1)
            FFMI = (fatFreeMass / (height ^ 2)).toFixed(1)
            BMI = (bia.weight / (height ^ 2)).toFixed(1)
        }
    }





    return <div className="card mt-2 bg-black bg-opacity-10 text-white p-4">
        <div className="d-flex  justify-content-between mb-3">
            <div>
                <h4><i className="fa-solid fa-chart-pie text-muted"></i> BIA</h4>
            </div>
            <div>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} dateFormat="dd/mm/yy" />
            </div>
        </div>

        {
            bia != null ?
                <div className="row">
                    <div className="col">
                        <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                                <Pie
                                    data={fatRatios}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    stroke="#000000"
                                    strokeOpacity={0.2}
                                    strokeWidth={5}
                                    outerRadius={130}
                                    innerRadius={100}
                                    label={(entry) => entry.value && ` ${entry.name} ${(entry.percent * 100).toFixed(1)}% `}
                                >

                                    {/* {data.map((entry, index) => (
                                        type == "type" ?
                                            <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                            : <Cell key={index} fill={getStatusColor(entry.name)} />
                                    ))} */}

                                    {fatRatios.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} fontSize={14} />
                                    ))}
                                </Pie>
                                <Pie
                                    data={waterRatios}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    stroke="#000000"
                                    strokeOpacity={0.2}
                                    strokeWidth={0}
                                    outerRadius={90}
                                    innerRadius={70}
                                //label={(entry) => entry.value && ` ${entry.name} ${(entry.percent * 100).toFixed(1)}% `}
                                >

                                    {/* {data.map((entry, index) => (
                                        type == "type" ?
                                            <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                            : <Cell key={index} fill={getStatusColor(entry.name)} />
                                    ))} */}

                                    {waterRatios.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} fontSize={14} />
                                    ))}
                                </Pie>
                                <Pie
                                    data={muscleRatios}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    stroke="#000000"
                                    strokeOpacity={0.2}
                                    strokeWidth={0}
                                    outerRadius={60}
                                    innerRadius={40}
                                //label={(entry) => entry.value && ` ${entry.name} ${(entry.percent * 100).toFixed(1)}% `}
                                >

                                    {/* {data.map((entry, index) => (
                                        type == "type" ?
                                            <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                            : <Cell key={index} fill={getStatusColor(entry.name)} />
                                    ))} */}

                                    {muscleRatios.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} fontSize={14} />
                                    ))}
                                </Pie>
                                <Tooltip formatter={(value) => `${value} kg`} />
                            </PieChart>
                        </ResponsiveContainer>

                    </div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span >Weight</span>
                                <h4>{bia.weight.toFixed(1)} kg</h4>
                            </div>
                        </div>
                        <hr />
                        <div className="row py-3">

                            <div className="col" >
                                <span style={{ color: tbwColor }}>TBW</span>
                                <h4>{bia.water.toFixed(1)} <small className="text-muted">kg</small></h4>
                            </div>
                            <div className="col">
                                <div className="col">
                                    <span>BMR</span>
                                    <h4>{bia.BMR.toFixed(1)} <small className="text-muted">kcal</small></h4>
                                </div>

                            </div>
                        </div>
                        <div className="row py-3">
                            <div className="col m-1 bg-dark bg-opacity-50">
                                <span>BMI</span>
                                <h4>{BMI}</h4>
                            </div>
                            <div className="col m-1 bg-dark bg-opacity-50">
                                <span>FMI</span>
                                <h4>{FMI}</h4>
                            </div>
                            <div className="col m-1 bg-dark  bg-opacity-50">
                                <span>FFMI</span>
                                <h4>{FFMI}</h4>
                            </div>
                        </div>

                        <div className="row">

                            <div className="col">
                                <span style={{ color: smmColor }}>Skeletal Muscle Mass</span>
                                <h4 >{bia.muscle_mass.toFixed(1)} <small className="text-muted"> kg</small></h4>
                                <span>{SMI} %</span>
                            </div>
                            <div className="col">
                                <span style={{ color: fmColor }}>Fat Mass</span>
                                <h4>{((bia.fat_ratio / 100) * bia.weight).toFixed(1)} <small className="text-muted"> kg</small></h4>
                                <span>{fmRatio} %</span>
                            </div>
                            <div className="col">
                                <span style={{ color: ffmColor }}>Fat Free Mass</span>
                                <h4>{((1 - (bia.fat_ratio / 100)) * bia.weight).toFixed(1)} <small className="text-muted"> kg</small></h4>
                                <span>{ffmRatio} %</span>
                            </div>
                        </div>





                    </div>


                </div>

                : <h3 className="text-muted">{t("health:helper.no_data")}</h3>
        }
    </div>
}

